export default class Options {
  private readonly validDetectors = ["param", "cookie", "localStorage", "injection", "referrer"];
  private readonly merchandisingMergeModes = ["none", "non-valid-campaign", "no-offer-campaign-items", "all"];
  private readonly apiVersions = [1, 2];
  private readonly campaignUuids = "";

  private validDetector: string[];
  private merchandisingMergeMode: string;
  private campaignUuid: string;
  private apiVersion: number = 1;

  constructor(options: Record<string, any>) {
    options = {
      ...options
    };
    this.validDetector = options.validDetector ?? this.validDetectors;
    this.merchandisingMergeMode = options.merchandisingMergeMode ?? this.merchandisingMergeModes[0];
    this.campaignUuid = options.campaignUuid ?? this.campaignUuids;
    this.apiVersion = options.apiVersion ?? this.apiVersions[0];

    this.validateOptions();
  }

  private validateOptions() {
    if (
      !Array.isArray(this.validDetector) ||
      !this.validDetector.every((val: any) => this.validDetectors.indexOf(val) > -1)
    ) {
      throw new Error(
        "validDetector in passed option is not valid! accepted options is an array of param, cookie, localStorage, referrer, injection"
      );
    }

    if (this.merchandisingMergeModes.indexOf(this.merchandisingMergeMode) === -1) {
      throw new Error(
        "merchandisingMergeMode in passed option is not valid! accepted options are none, non-valid-campaign, no-offer-campaign-items, all"
      );
    }

    if (this.isValidDetector("injection") && (!this.campaignUuid || this.campaignUuid.length === 0)) {
      throw new Error("Missing campaignUuid property while using injection case or not valid campaignUuid");
    }

    if (this.apiVersions.indexOf(this.apiVersion) === -1) {
      throw new Error("apiVersion in passed option is not valid! accepted options are 1, and 2");
    }
  }

  public isValidDetector(detector: string): boolean {
    return this.validDetector.indexOf(detector) > -1;
  }

  public merchandisingShouldBeMerged(isAValidCampaign: boolean = true): boolean {
    const currentMerchandisingMergeMode =
      this.merchandisingMergeMode === "none" ? this.merchandisingMergeMode : "non-valid-campaign";

    //NOTE: There was a logic before to merge the merchandising in all / non-offer articles. In case of need it's available in the old commits.
    return currentMerchandisingMergeMode === "non-valid-campaign" && !isAValidCampaign;
  }

  public getApiVersion(): number {
    return this.apiVersion;
  }
}
